export default __webpack_public_path__ + "static/media/iron_ingot.ca4f03cb.png";